import { Table } from "../../../../../services/tables/models";
import { action, computed, makeAutoObservable, runInAction } from "mobx";
import rootStore from "../../../../../stores";
import {
    createTables,
    deleteTable,
    getTables,
    updateTable,
    createTable,
    updateTableExternalId
} from "../../../../../services/tables";
import {
    CreateTablesRequest,
    DeleteTableRequest, TablesCreateTableRequest, UpdateTableExternalIdRequest,
    UpdateTableRequest
} from "../../../../../services/tables/requestsResponses";
import { ExecutionStatus } from "../../../../../services/general/requestsResponses";
import { updateMenuItemExternalId } from "../../../../../services/menu";
import {LocalizedString} from "../../../../../services/general/models";


export enum PageFormType{
    editAndCreateTable = "editAndCreateTable",
    deleteTable = "deleteTable"
}

class PageStore {

    constructor() {
        makeAutoObservable(this)
    }

    tables: Table[] = [];
    isReady:boolean = false;
    isError: boolean = false;

    forms: {
        [PageFormType.deleteTable]: {
            currentTable?: Table,
            isFormOpen: boolean
        },
        [PageFormType.editAndCreateTable]: {
            currentTable?: Table,
            isFormOpen: boolean
        },
    } = {
        [PageFormType.deleteTable]: {
            isFormOpen: false
        },
        [PageFormType.editAndCreateTable]: {
            isFormOpen: false
        },
    }


    async loadTables(){
        const authStore = rootStore.authStore;
        const response = await getTables(authStore.currentUser.organizationData.organizationBranchId);
        runInAction(() => {
            this.tables = response.tables.sort((a, b) =>  {
                return a.data.publicId - b.data.publicId
            });
            this.isReady = true;
        })

    }


    async createTables (data: CreateTablesRequest) {
        const response = await createTables(data);
        if(!response){
            runInAction(()=> {
                this.isError = true;
            });
            return;
        }
        await this.loadTables();
        this.isError = false;
        return response.executionStatus === ExecutionStatus.Finished;
    }

    async createTable (data: TablesCreateTableRequest) {
        const response = await createTable(data);
        if(!response){
            runInAction(()=> {
                this.isError = true;
            });
            return;
        }
        await this.loadTables();
        this.isError = false;
        return response.executionStatus === ExecutionStatus.Finished;
    }

    async updateTable (dataUpdateTables: UpdateTableRequest) {
        const response = await updateTable(dataUpdateTables);
        if(!response){
            runInAction(()=> {
                this.isError = true;
            });
            return;
        }
        await this.loadTables();
        this.isError = false;
        return response.executionStatus === ExecutionStatus.Finished;

    }

    async deleteTable (dataDeleteTables: DeleteTableRequest) {
        const response = await deleteTable(dataDeleteTables);
        if(!response){
            runInAction(()=> {
                this.isError = true;
            });
            return;
        }
        await this.loadTables();
        this.isError = false;
        return response.executionStatus === ExecutionStatus.Finished;

    }

    async updateExternalId(data: UpdateTableExternalIdRequest) {
        const response = await updateTableExternalId(data);
        if(!response){
            return;
        }

        return response.executionStatus === ExecutionStatus.Finished;

    }

    @action
    setNewTableName (name: LocalizedString) {
        this.forms[PageFormType.editAndCreateTable].currentTable.data.title = name;
    }
    @action
    setNewTableDescription (description: LocalizedString) {
        this.forms[PageFormType.editAndCreateTable].currentTable.data.description = description;
    }

    @action
    openForm(type: PageFormType, current?: Table){
        this.forms[type].isFormOpen = true;
        this.forms[type].currentTable = current;
    }

    @action
    closeForm(type: PageFormType){
        this.forms[type].isFormOpen = false;
        this.forms[type].currentTable = undefined;
    }

    @computed
    getMaxPublicId (){
        let arr = this.tables;
        let maxNumber = arr.reduce(function(max, current) {
            return max > current.data.publicId ? max : current.data.publicId;
          }, 0);
        return maxNumber;
    }
}


export default PageStore
